var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: !_vm.custom || _vm.custom.searchList.length === 0,
          expression: "!custom || custom.searchList.length===0"
        }
      ],
      staticClass: "dynamic-query layout-page scroll-page",
      attrs: { "element-loading-spinner": "none" }
    },
    [
      _c(
        "ybl-form",
        { ref: "form", attrs: { model: _vm.form, inline: true } },
        [
          _vm.isUltimate
            ? _c(
                "el-form-item",
                { key: "index", attrs: { label: "分支机构：" } },
                [
                  _c(
                    "ybl-select",
                    { attrs: { showSelect: true, custom: true } },
                    [
                      _c("ybl-multi-select", {
                        attrs: {
                          slot: "select",
                          items: _vm.partner.branchList,
                          props: _vm.partner.props,
                          placeholder: "请选择分支机构",
                          clearable: "",
                          filterable: "",
                          "filter-method": _vm.filterPartner
                        },
                        on: {
                          focus: _vm.focusPartner,
                          change: function($event) {
                            return _vm.partnerChange($event)
                          }
                        },
                        slot: "select",
                        model: {
                          value: _vm.partner.defaultVal,
                          callback: function($$v) {
                            _vm.$set(_vm.partner, "defaultVal", $$v)
                          },
                          expression: "partner.defaultVal"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.custom.searchList, function(item, index) {
            return [
              +item.frontEleType === 11
                ? _c("ybl-date-time", {
                    key: index,
                    attrs: { diff: 1, unit: "y" },
                    model: {
                      value: item.defaultVal,
                      callback: function($$v) {
                        _vm.$set(item, "defaultVal", $$v)
                      },
                      expression: "item.defaultVal"
                    }
                  })
                : _c(
                    "el-form-item",
                    {
                      key: index,
                      class: {
                        "ultimate-item": _vm.isUltimate && index === 0,
                        "el-form-item__long": item.showName.length >= 18
                      },
                      attrs: { label: item.showName + "：" }
                    },
                    [
                      +item.id === 1533 ||
                      item.tableName + "_" + item.fieldName ===
                        "insuranceinfo_InsuranceTypes"
                        ? _c(
                            "ybl-select",
                            { attrs: { showSelect: true, custom: true } },
                            [
                              _c("ybl-insurance-type", {
                                attrs: {
                                  slot: "select",
                                  showCheckbox: +item.isMutiSelect === 1,
                                  placeholder: "请选择" + item.showName,
                                  props: _vm.props,
                                  insSupplierList: _vm.supplierList,
                                  isFeiche: _vm.isFeiche
                                },
                                slot: "select",
                                model: {
                                  value: item.defaultVal,
                                  callback: function($$v) {
                                    _vm.$set(item, "defaultVal", $$v)
                                  },
                                  expression: "item.defaultVal"
                                }
                              })
                            ],
                            1
                          )
                        : [1575, 3962].includes(+item.id)
                        ? _c(
                            "ybl-select",
                            { attrs: { showSelect: true, custom: true } },
                            [
                              _c("ybl-insurance-type", {
                                attrs: {
                                  slot: "select",
                                  showCheckbox: true,
                                  dataType: 4,
                                  placeholder: "1请选择" + item.showName,
                                  props: _vm.props,
                                  insSupplierList: _vm.supplierList,
                                  isFeiche: _vm.isFeiche || _vm.isFinance
                                },
                                slot: "select",
                                model: {
                                  value: item.defaultVal,
                                  callback: function($$v) {
                                    _vm.$set(item, "defaultVal", $$v)
                                  },
                                  expression: "item.defaultVal"
                                }
                              })
                            ],
                            1
                          )
                        : [10].includes(+item.frontEleType) &&
                          ![1533, 1575, 3962].includes(+item.id)
                        ? _c(
                            "ybl-select",
                            { attrs: { showSelect: true, custom: true } },
                            [
                              _c("ybl-select-tree", {
                                ref: "stree_" + item.id,
                                refInFor: true,
                                attrs: {
                                  slot: "select",
                                  items: item.dictList,
                                  props: _vm.treeDefaultProps,
                                  placeholder: "请选择" + item.showName,
                                  clearable: ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.treeClear(item)
                                  }
                                },
                                slot: "select",
                                model: {
                                  value: item.defaultVal,
                                  callback: function($$v) {
                                    _vm.$set(item, "defaultVal", $$v)
                                  },
                                  expression: "item.defaultVal"
                                }
                              })
                            ],
                            1
                          )
                        : item.isTabFilter
                        ? _c(
                            "ybl-select",
                            { attrs: { showSelect: true, custom: true } },
                            [
                              _c("ybl-radio-group", {
                                attrs: {
                                  slot: "select",
                                  label: "",
                                  checked: item.defaultVal,
                                  showClose: true,
                                  options: item.dictList,
                                  props: _vm.defaultProps,
                                  "label-width": "100px"
                                },
                                on: {
                                  "update:checked": function($event) {
                                    return _vm.$set(item, "defaultVal", $event)
                                  },
                                  change: _vm.radioChange
                                },
                                slot: "select"
                              })
                            ],
                            1
                          )
                        : [2, 3].includes(+item.frontEleType) &&
                          +item.isMutiSelect === 1
                        ? _c(
                            "ybl-select",
                            { attrs: { showSelect: true, custom: true } },
                            [
                              _c("ybl-multi-select", {
                                attrs: {
                                  slot: "select",
                                  items: item.dictList,
                                  props:
                                    +item.sourceType === 2
                                      ? _vm.staticProps
                                      : _vm.jobnumProps,
                                  "label-select":
                                    +item.sourceType === 1 &&
                                    /出单员|业务员|录单员|收款人/.test(
                                      item.showName || ""
                                    ),
                                  placeholder: "请选择" + item.showName,
                                  clearable: "",
                                  filterable: "",
                                  "filter-method": _vm.filterEvent
                                },
                                on: {
                                  focus: function($event) {
                                    return _vm.focusEvent(item)
                                  },
                                  change: function($event) {
                                    return _vm.relationChange($event, item)
                                  }
                                },
                                slot: "select",
                                model: {
                                  value: item.defaultVal,
                                  callback: function($$v) {
                                    _vm.$set(item, "defaultVal", $$v)
                                  },
                                  expression: "item.defaultVal"
                                }
                              })
                            ],
                            1
                          )
                        : [2, 3].includes(+item.frontEleType) &&
                          +item.isMutiSelect === 0
                        ? _c(
                            "ybl-select",
                            { attrs: { showSelect: true, custom: true } },
                            [
                              _c(
                                "el-select",
                                {
                                  ref: item.id,
                                  refInFor: true,
                                  attrs: {
                                    slot: "select",
                                    placeholder: "请选择" + item.showName,
                                    filterable: true,
                                    clearable: "",
                                    "filter-method": _vm.filterEvent
                                  },
                                  on: {
                                    focus: function($event) {
                                      return _vm.focusEvent(item)
                                    }
                                  },
                                  slot: "select",
                                  model: {
                                    value: item.defaultVal,
                                    callback: function($$v) {
                                      _vm.$set(item, "defaultVal", $$v)
                                    },
                                    expression: "item.defaultVal"
                                  }
                                },
                                _vm._l(item.dictList, function(o) {
                                  return _c("el-option", {
                                    key: o.keyCode || o.Value,
                                    attrs: {
                                      label: _vm.getLabel(item, o),
                                      value: o.keyCode || o.Value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : item.frontEleType === 8
                        ? _c(
                            "ybl-select",
                            { attrs: { showSelect: true, custom: true } },
                            [
                              _c("ybl-date-range", {
                                attrs: { slot: "select", diff: 1, unit: "y" },
                                slot: "select",
                                model: {
                                  value: item.defaultVal,
                                  callback: function($$v) {
                                    _vm.$set(item, "defaultVal", $$v)
                                  },
                                  expression: "item.defaultVal"
                                }
                              })
                            ],
                            1
                          )
                        : item.frontEleType === 7
                        ? _c(
                            "ybl-select",
                            { attrs: { showSelect: true, custom: true } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  slot: "select",
                                  type: "date",
                                  placeholder: "选择日期"
                                },
                                slot: "select",
                                model: {
                                  value: item.defaultVal,
                                  callback: function($$v) {
                                    _vm.$set(item, "defaultVal", $$v)
                                  },
                                  expression: "item.defaultVal"
                                }
                              })
                            ],
                            1
                          )
                        : +item.frontEleType === 5
                        ? _c(
                            "ybl-select",
                            { attrs: { showSelect: true, custom: true } },
                            [
                              _c("ybl-area", {
                                attrs: {
                                  slot: "select",
                                  labels: ["", "", ""],
                                  level: 2
                                },
                                slot: "select",
                                model: {
                                  value: item.defaultVal,
                                  callback: function($$v) {
                                    _vm.$set(item, "defaultVal", $$v)
                                  },
                                  expression: "item.defaultVal"
                                }
                              })
                            ],
                            1
                          )
                        : +item.frontEleType === 6
                        ? _c(
                            "ybl-select",
                            { attrs: { showSelect: true, custom: true } },
                            [
                              _c("ybl-area", {
                                attrs: { slot: "select", labels: ["", "", ""] },
                                slot: "select"
                              })
                            ],
                            1
                          )
                        : +item.frontEleType === 9
                        ? _c(
                            "ybl-select",
                            { attrs: { showSelect: true, custom: true } },
                            [
                              _c("ybl-num-range", {
                                attrs: { slot: "select" },
                                slot: "select",
                                model: {
                                  value: item.defaultVal,
                                  callback: function($$v) {
                                    _vm.$set(item, "defaultVal", $$v)
                                  },
                                  expression: "item.defaultVal"
                                }
                              })
                            ],
                            1
                          )
                        : _c("ybl-input", {
                            attrs: {
                              type: "text",
                              showSelect: true,
                              placeholder: "请输入" + item.showName,
                              clearable: ""
                            },
                            model: {
                              value: item.defaultVal,
                              callback: function($$v) {
                                _vm.$set(item, "defaultVal", $$v)
                              },
                              expression: "item.defaultVal"
                            }
                          }),
                      _vm._v(" "),
                      _vm.ignoreTimeEnabled &&
                      _vm.hasPreciseFieldValue &&
                      item.tableName + "_" + item.fieldName + "_" + item.id ===
                        _vm.dateRangeFieldKey
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.ignoreTime
                                  ? "已忽略日期区间，点击让日期条件生效"
                                  : "日期区间已生效，点击忽略日期条件",
                                placement: "top"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "ignore-time-icon el-icon-time",
                                class: { "is-include-time": !_vm.ignoreTime },
                                on: {
                                  click: function($event) {
                                    _vm.ignoreTime = !_vm.ignoreTime
                                  }
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
            ]
          }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "form-search-button", attrs: { label: "" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.search } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.reset } }, [_vm._v("重置")])
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ybl-table-list",
        {
          ref: "dynamicTable",
          attrs: {
            data: _vm.queryList,
            border: "",
            total: _vm.queryTotal,
            change: _vm.pageChange,
            summary: _vm.summary,
            nowrap: true,
            filterValue: _vm.filterValue,
            multiple: _vm.multiple,
            operate: _vm.operate,
            operateWidth: _vm.operateWidth,
            multipleAll: _vm.multipleAll,
            setting: ![4].includes(+_vm.dynamicQueryType),
            selectable: _vm.checkSelectable
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "size-change": _vm.sizeChange,
            settingTable: _vm.openColumn,
            toggleSelectAll: _vm.toggleSelectAll
          }
        },
        [
          _vm.type !== "selection"
            ? _c("el-table-column", {
                attrs: {
                  type: _vm.type,
                  align: "center",
                  fixed: "left",
                  label: "序号"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isUltimate
            ? _c("el-table-column", {
                attrs: {
                  label: "分支机构",
                  align: _vm.tableAlign,
                  "min-width": "100",
                  fixed: ""
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n        " +
                              _vm._s(scope.row.fields["666"]) +
                              "\n      "
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  552381724
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.custom.availableList, function(item, index) {
            return [
              ![1578, 1579, 1580, 1577, 1582, 1581, 1576].includes(item.id)
                ? _c("el-table-column", {
                    key: "column_" + index,
                    attrs: {
                      label: item.showName,
                      align: _vm.tableAlign,
                      "min-width": [1166].includes(item.id) ? 200 : 120,
                      "max-width": "500",
                      "show-overflow-tooltip": ![1166].includes(item.id),
                      prop: "" + item.id,
                      fixed: index < 2
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              item.tableName + "_" + item.fieldName ===
                                "Insuranceinfo_branchorgid" &&
                              _vm.fn("8901") &&
                              "" + scope.row.fields[item.id] !== "0"
                                ? [
                                    _vm.isFeiche
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "cursor primary-color",
                                            on: {
                                              click: function($event) {
                                                return _vm.goToOrganizationDetail(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.fields[item.id])
                                            )
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "cursor primary-color",
                                            on: {
                                              click: function($event) {
                                                return _vm.goToOrganizationDetail(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.calcFieldText(
                                                  item.id,
                                                  scope.row,
                                                  item,
                                                  scope.$index
                                                )
                                              )
                                            )
                                          ]
                                        )
                                  ]
                                : item.tableName + "_" + item.fieldName ===
                                    "Insuranceinfo_salesmanId" &&
                                  _vm.fn("10686")
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "cursor primary-color",
                                        on: {
                                          click: function($event) {
                                            return _vm.goToCustomerDetail(
                                              scope.row
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.fields[item.id])
                                        )
                                      ]
                                    )
                                  ]
                                : [2, 3, 10].includes(+item.frontEleType)
                                ? [
                                    _vm.isFeiche
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.fields[item.id])
                                          )
                                        ])
                                      : _c(
                                          "span",
                                          {
                                            class: {
                                              red:
                                                [
                                                  1277,
                                                  1282,
                                                  1562,
                                                  1563
                                                ].includes(item.id) &&
                                                +scope.row.fields[item.id] === 0
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.calcFieldText(
                                                  item.id,
                                                  scope.row,
                                                  item,
                                                  scope.$index
                                                )
                                              )
                                            )
                                          ]
                                        )
                                  ]
                                : +item.showFormatType === 1
                                ? [
                                    item.tableName + "_" + item.fieldName ===
                                      "insurancesettle_RewardSettleRate" &&
                                    +_vm.dynamicQueryType === 4
                                      ? _c("span", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm._f("percent")(
                                                  scope.row.fields[item.id]
                                                )
                                              ) +
                                              " "
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-caret-bottom cursor",
                                            on: {
                                              click: function($event) {
                                                return _vm.openView(scope.row)
                                              }
                                            }
                                          })
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("percent")(
                                                scope.row.fields[item.id]
                                              )
                                            )
                                          )
                                        ])
                                  ]
                                : +item.showFormatType === 2
                                ? [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm._f("dateFormat")(
                                            scope.row.fields[item.id]
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                : +item.showFormatType === 3
                                ? [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm._f("Currency")(
                                            scope.row.fields[item.id]
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                : +item.id === 1166
                                ? [
                                    _vm.isUltimate
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.fields[item.id])
                                          )
                                        ])
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "cursor primary-color",
                                            on: {
                                              click: function($event) {
                                                return _vm.goToDetail(scope.row)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.fields[item.id])
                                            )
                                          ]
                                        )
                                  ]
                                : [
                                    +item.id === 1396 &&
                                    +_vm.sceneCategory === 30 &&
                                    scope.row.customBalanceUser
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [_vm._v("自定义")]
                                        )
                                      : _vm._e(),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(scope.row.fields[item.id]) +
                                        "\n          "
                                    )
                                  ]
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _vm.showRelation
            ? _c("el-table-column", {
                directives: [
                  { name: "isdataauthority", rawName: "v-isdataauthority" }
                ],
                attrs: {
                  label: "关联政策",
                  align: _vm.tableAlign,
                  "min-width": "100"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-button", {
                            class: { disabled: !_vm.renderPolicy(scope.row) },
                            attrs: { type: "text", icon: "el-icon-paperclip" },
                            on: {
                              click: function($event) {
                                return _vm.viewPolicy(scope.row)
                              }
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3244902801
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("action"),
          _vm._v(" "),
          _vm._t("summary", null, { slot: "summary" }),
          _vm._v(" "),
          _vm._t("batchButton", null, { slot: "batchButton" })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ybl-dialog",
        {
          attrs: {
            visible: _vm.dialog.visible,
            title: _vm.dialog.title,
            width: _vm.dialog.width,
            showFooter:
              ![17, 50, 400].includes(+_vm.dialog.step) || _vm.isBindQrcode,
            showHeader: ![50].includes(+_vm.dialog.step)
          },
          on: { close: _vm.close, confirm: _vm.dialogSubmit }
        },
        [
          +_vm.dialog.step < 3
            ? _c("ybl-condition", {
                ref: "dialog",
                attrs: {
                  fields: _vm.system[_vm.renderField],
                  groupCheckBox: +_vm.dialog.step === 2,
                  isFeiChe: _vm.isFeiche
                },
                on: { change: _vm.submit },
                model: {
                  value: _vm.custom[_vm.renderField],
                  callback: function($$v) {
                    _vm.$set(_vm.custom, _vm.renderField, $$v)
                  },
                  expression: "custom[renderField]"
                }
              })
            : +_vm.dialog.step === 40
            ? _c("template-fields", {
                ref: "dialog",
                attrs: {
                  item: _vm.currentTemplate,
                  templates: _vm.originTemplateList
                },
                on: { change: _vm.submitTemplate }
              })
            : +_vm.dialog.step === 400
            ? _c("ybl-qrcode", {
                ref: "dialog",
                on: { next: _vm.nextValidate }
              })
            : _c("ybl-export", {
                ref: "dialog",
                attrs: {
                  taskId: _vm.taskId,
                  isFeiche: _vm.isFeiche,
                  busiType: _vm.sceneCategory
                },
                on: { close: _vm.close, goTo: _vm.goTo }
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-485fff97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485fff97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicQueryNew.vue
// module id = null
// module chunks = 